import * as Yup from 'yup';

const validationSchema = () =>
  Yup.object().shape({
    id_address_area: Yup.string().required('Выберите район'),
    fio: Yup.string().required('ФИО обязательно к заполнению'),
  });

export default validationSchema;
